import Vue from "vue";
import validatePop from "@/plugins/validatePop.js";
const vm = new Vue();

export const checkMemberCod = async (tel, cardId) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + "/member/fetch",
        {
          card_id: cardId,
          tel: tel,
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        let data = res.data.data;
        let checkError = validatePop(res);
        if (!checkError.status) {
          reject(checkError);
        }
        resolve(data);
      });
  });
};

export const getIcon = async (courierIcon, typeIcon) => {
  return new Promise((resolve, reject) => {
    let icon = courierIcon ? courierIcon : "image.svg";
    const path =
      typeIcon && typeIcon === "service"
        ? `/icon/additional_service/${icon}`
        : `/icon/${icon}`;

    if (icon == "shippop-logo") {
      resolve("img/brand/logo-shippop.png");
    } else {
      const storageRef = vm.$firebase
        .storage()
        .ref(path)
        .getDownloadURL();
      storageRef
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve("img/brand/load-error.svg");
        });
    }
  });
};

export const sendErrorToLine = (res) => {
  vm.$http.post(
    vm.$API_URL + "/lineNotify/error",
    {
      error: res,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Token: localStorage.getItem("access_token"),
      },
    }
  );
};

export const getLabelHtml = (orderId, size, orderDetailId) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + `/order/${orderId}/label/${size}/${orderDetailId}`, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        resolve(res.data.data);
      });
  });
};

export const cancelOrderByOne = (orderId, orderDetailId) => {
  return new Promise((resolve, reject) => {
    if (!orderId) {
      resolve("newbill");
    } else {
      vm.$http
        .delete(vm.$API_URL + `/shop/order/${orderId}`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
          data: {
            list_cancel: orderDetailId,
            remark: "ยกเลิกรายการจากหน้า POS",
          },
        })
        .then((res) => {
          resolve(res.data);
        });
    }
  });
};

export const getLabelHtmlByTracking = (size, tracking , dropoff_type) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + `/shippop/labels`, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        params: {
          size: size,
          tracking_codes: tracking,
          dropoff_type: dropoff_type
        },
      })
      .then((res) => {
        resolve(res.data.data);
      });
  });
};
